/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedBillDtOs as DigiworkMaitreDPosDtoBillsPaginatedBillDtOs } from '../../models/Digiwork/MaitreD/Pos/DTO/Bills/paginated-bill-dt-os';
import { GetBillsPaginatedDto as DigiworkMaitreDPosDtoOrderV2GetBillsPaginatedDto } from '../../models/Digiwork/MaitreD/Pos/DTO/OrderV2/get-bills-paginated-dto';

export interface GetFilteredBillsPaginated$Params {
      body?: DigiworkMaitreDPosDtoOrderV2GetBillsPaginatedDto
}

export function getFilteredBillsPaginated(http: HttpClient, rootUrl: string, params?: GetFilteredBillsPaginated$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoBillsPaginatedBillDtOs>> {
  const rb = new RequestBuilder(rootUrl, getFilteredBillsPaginated.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoBillsPaginatedBillDtOs>;
    })
  );
}

getFilteredBillsPaginated.PATH = '/api/orders/bills/get-bills-paginated';
